import { przezmorzeApi, throwMessageOnStatuses } from "../../../api/api";
import type {
  CancellationCondition,
  CancellationConditionListResponse,
  CreateCancellationConditionRequest,
  CustomerCancellationCondition,
  UpdateCancellationConditionRequest,
} from "@przezmorze/api-types";

export type {
  CancellationCondition,
  CreateCancellationConditionRequest,
  CustomerCancellationCondition,
  UpdateCancellationConditionRequest,
};

export async function listCancellationConditions(abortSignal?: AbortSignal): Promise<CancellationCondition[]> {
  const response = await przezmorzeApi.get<CancellationConditionListResponse>("/cancellation-conditions", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function getCancellationCondition(
  conditionId: string,
  abortSignal?: AbortSignal,
): Promise<CustomerCancellationCondition> {
  const response = await przezmorzeApi.get<CustomerCancellationCondition>(`/cancellation-conditions/${conditionId}`, {
    signal: abortSignal,
  });
  return response.data;
}

export async function addCancellationCondition(
  body: CreateCancellationConditionRequest,
  abortSignal?: AbortSignal,
): Promise<CancellationCondition> {
  try {
    const response = await przezmorzeApi.post<CancellationCondition>("/cancellation-conditions", body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [400, 409]);
  }
}

export async function updateCancellationCondition(
  conditionId: string,
  body: UpdateCancellationConditionRequest,
  abortSignal?: AbortSignal,
): Promise<CancellationCondition> {
  try {
    const response = await przezmorzeApi.put<CancellationCondition>(`/cancellation-conditions/${conditionId}`, body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [400, 409]);
  }
}

export async function deleteCancellationCondition(conditionId: string, abortSignal?: AbortSignal): Promise<void> {
  await przezmorzeApi.delete<void>(`/cancellation-conditions/${conditionId}`, {
    signal: abortSignal,
  });
}
